import React from 'react';
import styled from 'styled-components';
import styles from '../../utility/styles';

const SliderContainer = styled.div`
    position: relative;
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
`;

const SliderTrack = styled.div`
    width: 100%;
    height: 8px;
    background-color: ${styles.colors.darkGray};
    border-radius: 2px;
    position: relative;
`;

const SliderProgress = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => props.percentage}%;
    background-color: ${props => props.progressColor || '#10B981'};
    border-radius: 2px;
    transition: width 0.1s ease;
`;

const SliderThumb = styled.div`
    position: absolute;
    top: 50%;
    left: ${props => props.percentage}%;
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 2;
`;

const ThumbSVG = styled.svg`
    width: 32px;
    height: 32px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
`;

const ThumbText = styled.text`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 10px;
    font-weight: 600;
    fill: #1A1E25;
    text-anchor: middle;
    dominant-baseline: central;
`;

const HiddenInput = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
`;

export default function Slider({ value, onChange, min = 0, max = 100, step = 1, progressColor, style }) {
    const percentage = ((value - min) / (max - min)) * 100;

    const handleChange = (e) => {
        const newValue = parseFloat(e.target.value);
        onChange(newValue);
    };

    return (
        <SliderContainer style={style}>
            <SliderTrack>
                <SliderProgress percentage={percentage} progressColor={progressColor} />
                <SliderThumb percentage={percentage}>
                    <ThumbSVG width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="2" fill="white" />
                        <ThumbText x="16" y="16">
                            {value}
                        </ThumbText>
                        <rect x="8.89844" y="22" width="2.05078" height="6" fill="#9EA6B7" />
                        <rect x="12.9531" y="22" width="2.05078" height="6" fill="#9EA6B7" />
                        <rect x="17" y="22" width="2.05078" height="6" fill="#9EA6B7" />
                        <rect x="21.0469" y="22" width="2.05078" height="6" fill="#9EA6B7" />
                    </ThumbSVG>
                </SliderThumb>
                <HiddenInput
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={handleChange}
                />
            </SliderTrack>
        </SliderContainer>
    );
}